import TimeAgo from 'javascript-time-ago';

import {
  Twig,
  Tag,
  User,
  Business,
  Product,
  Currency,
  TwigButton,
  Location,
  ProductOptions,
  ProductVariant,
  Category,
  City,
  Area,
  DeliveryZone,
  Address,
  MetaData,
  SpotLight,
  Country,
  Brand,
  PriceArea,
  userToken,
  Article,
  RegistrationInfo,

} from '../types';
import en from 'javascript-time-ago/locale/en.json'

export function transformAreas(data: any): Area {
  return {
    id: data.id,
    name: data.name || '',
    code: data.code || '',
    price: data.price || 0,
    default_price: data.default_price,
    prices: data.prices.length > 0 ? data.prices.map(transformPriceArea) : [],
    cash_on_delivery_high: data.cash_on_delivery_high,
    cash_on_delivery_low: data.cash_on_delivery_low
  };

}
export function transformArticle(data: any): Article {
  return {
    id: data.id,
    title: data.title,
    username: data.username,
    header: data.header,
    content: data.content,
    user_id: data.user_id,
    business_id: data.business_id,
    cover: data.cover,
    created_at: data.created_at,
    products: data.products ? data.products.map(transformProduct) : [],
    user: data.user ? transformUser(data.user) : getUserSkeleton(),
    createdAtAsString: dateFormat(data.created_at),
  };
}

export function transformPriceArea(data: any): PriceArea {
  return {
    max_weight: data.max_weight,
    min_weight: data.min_weight,
    price: data.price
  };

}

export function transformTwig(data: any): Twig {
  return {
    id: data.id,
    uniqueName: data.username,
    description: data.description,
    price: data.price,
    transformedPrice: data.transformed_price,
    qualityScore: data.quality,
    serviceScore: data.service,
    priceScore: data.reasonable_price,
    ambianceScore: data.ambiance,
    favorites: data.favorites || 0,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    mediaUrl: data.media_object?.media || data.media,
    mediaThumbUrl:
      data.media_object?.type === 'VIDEO'
        ? data.media_object?.thumb
        : data.media || '',
    mediaType: data.media_object?.type || 'IMAGE',
    tags: data.tags ? data.tags.map(transformTag) : [],
    user: data.user ? transformUser(data.user) : getUserSkeleton(),
    business: data.business
      ? transformBusiness(data.business)
      : getBussinessSkeleton(),
    product:
      data.products && data.products.length
        ? transformProduct(data.products[0])
        : getProductSkeleton(),
    isFavourite: data.in_todo,
    buttons: data.btns ? data.btns.map(transformTwigButton) : [],
    category: data.category ? transformCategory(data.category) : undefined,
    subCategory: data.sub_category ? transformCategory(data.sub_category) : undefined,
    views: data.views * 3 > 1024 ? (data.views * 3 / 1000).toFixed(2) + " K" : (data.views * 3).toString()
  };
}

export function transformProductOption(option: any) {
  var tempOptionValue: any[] = []
  for (let index = 0; index < option.option_values.length; index++) {
    const element = option.option_values[index];
    if (element.products_count != 0) {
      tempOptionValue.push(element)
    }
  }
  return {
    id: option.id,
    name: option.name,
    option_values: tempOptionValue
  };
}
export function transformTag(tag: any): Tag {
  return {
    id: tag.id,
    name: tag.name,
    weight: tag.weight,
    isFeatured: tag.is_featured,
  };
}

export function transformUser(user: any): User {
  return {
    id: user.id,
    uniqueName: user.username,
    avatarUrl: user.photo,
    email: user.email,
    name: user.name,
    phoneNumber: user.phone_number,
    username: user.username,
    coverUrl: user.cover,
    position: user.position,
    about: user.about,
    score: user.score,
    twigs: user.twigs ? user.twigs.map(transformTwig) : [],
    followersCount: user.followers_count,
    followingCount: user.following_count,
    likesCount: user.likes_count,
    twigsCount: user.twigs_count,
    instagram: user.instagram,
    facebook: user.facebook,
    twitter: user.twitter,
    website: user.website,
    pinterest: user.pinterest,
    addresses: user.addresses ? user.addresses.map(transformAddress) : [],
    businesses: user.businesses ? user.businesses.map(transformBusiness) : [],
    is_guest: user.is_guest,
    gender: user.gender,
    photo: user.photo,
  };
}

export function transformUserToken(user: any): userToken {
  return {
    ...transformUser(user),
    token: user.token
  }
}

export function transformBusiness(data: any): Business {
  return {
    id: data.id,
    name: data.name,
    email: data.email,
    promotional_text: data.promotional_text,
    phone: data.phone,
    uniqueName: data.username,
    return_and_exchanges_policy: data.return_and_exchanges_policy,
    type: data.type,
    address: data.address,
    coverUrl: data.cover,
    description: data.description,
    logoUrl: data.logo,
    products: data.products ? data.products.map(transformProduct) : [],
    industry: {
      id: data.industry ? data.industry.id : '',
      name: data.industry ? data.industry.name : '',
    },
    facebook: data.facebook,
    instagram: data.instagram,
    pinterest: data.pinterest,
    twitter: data.twitter,
    website: data.website,
    categories: data.categories ? data.categories.map(transformCategory) : [],
    statistics: data.statistics ? data.statistics : {},
    locations: data.locations ? data.locations.map(transformLocation) : [],
    deliveryZones: data.delivery_zones
      ? data.delivery_zones.map(transformDeliveryZone)
      : [],
  };
}
export function transformSpotLight(data: any): SpotLight {
  var parametar = "fullAll=true&";
  if (data.category)
    parametar += "categoryId=" + data.category.id + "&"
  if (data.sub_category)
    parametar += "subcategoryId=" + data.sub_category.id + "&"
  if (data.brand)
    parametar += "brandId=" + data.brand.id + "&"
  if (data.gender)
    parametar += "gender=" + data.gender + "&"
  if (data.keyword)
    parametar += "searchKey=" + data.keyword + "&"
  if (data.min_price)
    parametar += "min_price=" + data.min_price + "&"
  if (data.max_price)
    parametar += "max_price=" + data.max_price + "&"
  if (data.tags && data.tags.length > 0) {
    let tagArray: any[] = [];
    data.tags.forEach((element: { name: any; }) => {
      tagArray.push(element.name)
    });
    parametar += "tags=" + tagArray.toString()
  }
  // parametar += "latitude=" [+ data.latitude + "&longitude=" + data.longitude
  return {
    id: data.id,
    photo: data.photo,
    latitude: data.latitude,
    longitude: data.longitude,
    name: data.name,
    category: data.category ? transformCategory(data.category) : undefined,
    parametar: parametar
  }
}
export function transformProduct(data: any): Product {
  const product: Product = {
    status: data.status,
    original_url: data.original_url,
    affiliate: data.affiliate,
    affiliate_link: data.affiliate_link,
    id: data.id,
    is_verified: data.is_verified == 1 ? true : false,
    overSellEnabled: data.over_sell_enabled == 1 ? true : false,
    name: data.name,
    brand: data.brand ? transformBrand(data.brand) : null,
    uniqueName: data.username,
    currency: data.currency
      ? transformCurrency(data.currency)
      : getCurrencySkeleton(),
    description: data.description,
    tags: data.tags ? data.tags.map(transformTag) : [],
    photo: data.photo,
    price: data.price,
    originalPrice: data.original_price,
    discountedPrice: data.discounted_price || 0,
    business: data.business
      ? transformBusiness(data.business)
      : getBussinessSkeleton(),
    options: transformProductOptions(data.option_values),
    images: data.images ? [data.photo, ...data.images] : [data.photo],
    variants: data.variants ? data.variants.map(transformProductVariant) : [],
    totalQuantity: data.total_quantity,
    weight: data.weight
  };

  return product;
}

export function transformProductOptions(data: any): ProductOptions {
  const ret: ProductOptions = {};
  if (!data) return ret;
  Object.keys(data).forEach((key) => {
    const values = data[key];
    values.forEach((value: any) => {
      if (!Array.isArray(ret[value.option.name])) {
        ret[value.option.name] = [];
      }

      ret[value.option.name].push({
        id: value.id,
        optionID: value.option_id,
        value: value.value,
        title: value.title,
      });
    });
  });

  return ret;
}

export function transformProductVariant(data: any): ProductVariant {
  return {
    id: data.id,
    productID: data.product_id,
    barcode: data.barcode,
    price: data.price,
    quantity: data.quantity,
    image: data.image,
    sku: data.sku || '',
    optionValues: data.option_values
      ? data.option_values.map((option: any) => ({
        id: option.id,
        optionID: option.option.id,
        value: option.value,
        name: option.option.name,
      }))
      : [],
  };
}

export function transformCurrency(currency: any): Currency {
  return {
    id: currency.id,
    countryCode: currency.country_code,
    currencyCode: currency.currency_code,
    value: currency.value,
  };
}

export function transformLocation(data: any): Location {
  return {
    id: data.id,
    name: data.name,
    address: data.address,
    latitude: data.latitude,
    longitude: data.longitude,
  };
}

export function transformTwigButton(btn: any): TwigButton {
  return {
    id: btn.id,
    title: btn.title,
    twigID: btn.twig_id,
    action: btn.action,
    status: btn.status,
    type: btn.type,
  };
}

export function transformCategory(data: any): Category {
  return {
    id: data.id,
    color: data.color || '',
    cover: data.cover || '',
    status: data.status || '',
    name: data.name || '',
    photo: data.photo || '',
    isNav: data.is_nav == 1 ? true : false,
    Subcategory: data.sub_categories && data.sub_categories.length > 0 ? data.sub_categories.map(transformCategory) : [],
    brands: data.brands ? data.brands.map(transformBrand) : [],
    products_trending: data.products_trending ? data.products_trending.map(transformProduct) : []
  };
}


export function transformBrand(data: any): Brand {
  return {
    id: data.id,
    name: data.name,
    logo: data.logo
  };
}


export function transformCity(data: any): City {
  return {
    id: data.id,
    name: data.name || '',
    areas: data.areas ? data.areas.map(transformAreas) : []
  };
}


export function transformCountry(data: any): Country {
  return {
    id: data.id,
    calling_code: data.calling_code || '',
    cctld: data.cctld || '',
    currencyCode: data.currencyCode || '',
    iso2: data.iso2 || '',
    iso3: data.iso3 || '',
    long_name: data.long_name || '',
    numcode: data.numcode || '',
    short_name: data.short_name || '',
    is_cash_on_delivery_supported: data.is_cash_on_delivery_supported == 1 ? true : false,
    un_member: data.un_member || '',
    is_delivery_supported: data.is_delivery_supported,

  };
}

export function transformAddress(data: any): Address {
  return {
    id: data.id,
    name: data.name || '',
    label: data.label || '',
    note: data.note || '',
    city: data.city || {},
    building: data.building || '',
    street_name: data.street_name || '',
    phone: data.phone || '',
    country: data.country ? transformCountry(data.country) : null,
    area: data.area || null,
  };
}


export function transformDeliveryZone(data: any): DeliveryZone {
  return {
    id: data.id,
    name: data.name || '',
    cost: data.cost || 0,
    transformedCost: data.transformed_cost || 0,
    city_id: data.city?.id,
  };
}

export function getTwigSkeleton(): Twig {
  return {
    id: '',
    price: 0,
    uniqueName: '',
    transformedPrice: 0,
    ambianceScore: 0,
    serviceScore: 0,
    priceScore: 0,
    views: "0",
    qualityScore: 0,
    createdAt: '',
    updatedAt: '',
    buttons: [],
    business: getBussinessSkeleton(),
    product: getProductSkeleton(),
    tags: [],
    description: '',
    favorites: 0,
    mediaType: 'IMAGE',
    mediaUrl: '',
    mediaThumbUrl: '',
    isFavourite: false,
    user: getUserSkeleton()
  };
}

export function getBrandSkeleton(): Brand {
  return {
    name: "",
    id: "",
    logo: ""
  }
}

export function getBussinessSkeleton(): Business {
  return {
    id: '',
    uniqueName: '',
    email: '',
    phone: '',
    address: '',
    type: '',
    coverUrl: '',
    description: '',
    logoUrl: '',
    name: '',
    products: [],
    categories: [],
    promotional_text: '',
    industry: {
      id: '',
      name: '',
    },
    statistics: { "ambiance": 0, "followers": 0, "likes": 0, "offers": 0, "price": 0, "quality": 0, "service": 0 },
    locations: [],
    deliveryZones: [],
  };
}

export function getUserSkeleton(): User {
  return {
    id: '',
    uniqueName: '',
    avatarUrl: '',
    email: '',
    phoneNumber: '',
    name: '',
    username: '',
    coverUrl: '',
    score: 0,
    about: "",
    position: '',
    twigs: [],
    followersCount: 0,
    followingCount: 0,
    likesCount: 0,
    twigsCount: 0,
    addresses: [],
    businesses: [],
    is_guest: false,
    gender: '',
  };
}

export function getProductSkeleton(): Product {
  return {
    weight: 0,
    original_url: "",
    is_verified: false,
    overSellEnabled: false,
    affiliate_link: '',
    affiliate: '',
    id: '',
    uniqueName: '',
    currency: getCurrencySkeleton(),
    name: '',
    description: '',
    photo: '',
    price: 0,
    status: "",
    originalPrice: 0,
    discountedPrice: 0,
    business: getBussinessSkeleton(),
    brand: getBrandSkeleton(),
    options: {},
    images: [],
    tags: [],
    variants: [],
    totalQuantity: 0,
  };
}

export function getCurrencySkeleton(): Currency {
  return {
    id: '',
    countryCode: '',
    currencyCode: '',
    value: 0,
  };
}

export function isTwig(data: any): boolean {
  return 'feelings' in data && 'user' in data;
}

export function isProduct(data: any): boolean {
  return 'option_values' in data && 'variants' in data;
}

export function isBusiness(data: any): boolean {
  return 'commercial_name' in data && 'legal_name' in data;
}

export function isUser(data: any): boolean {
  return 'is_guest' in data;
}
export function existUserDeliverAddress(data: any): boolean {
  return 'user_deliver_address' in data

}
export function setMetaData(data: MetaData): void {
  if (data.title) {
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", data.title);
    document.querySelector('meta[property="twitter:title"]')?.setAttribute("content", data.title);
  }
  if (data.image) {
    document.querySelector('meta[property="og:image"]')?.setAttribute("content", data.image);
    document.querySelector('meta[property="twitter:image"]')?.setAttribute("content", data.image);
    document.querySelector('meta[property="facebook:image"]')?.setAttribute("content", data.image);
  }
  if (data.description) {
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", data.description);
    document.querySelector('meta[property="twitter:description"]')?.setAttribute("content", data.description);
  }
  if (data.url) {
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", data.url);
  }
}
export function dateFormat(date: any): string {
  TimeAgo.addDefaultLocale(en)
  const timeAgo = new TimeAgo('en-US')
  let convertToDate = new Date(date);
  return ("" + timeAgo.format(convertToDate));
}

export const objectWithOutNull = (obj: any) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
}

export function convertToPlainText(htmlBody: any) {

  // Create a new div element
  var tempDivElement = document.createElement("div");

  // Set the HTML content with the given value
  tempDivElement.innerHTML = htmlBody;

  // Retrieve the text property of the element 
  return tempDivElement.textContent || tempDivElement.innerText || "";
}


